import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyles } from './LockMessageState.styles'
import {
  faFaceSmile,
  faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons'
import { useEffect, useState } from 'react'
import { footerStateType } from '../../../common/components/FooterV2/FooterV2'
import { DateTime } from 'luxon'
import { autoSaveThresoldTime } from '../../../common/utils/constants'
export const LockMessageState = ({
  sinceTime,
  lockByName,
  lockStatus,
  setLockStatus,
  userId,
  lockedBy,
  lockByEmail,
}: {
  sinceTime?: string
  lockByName?: string
  lockStatus?: string
  setLockStatus: React.Dispatch<React.SetStateAction<string>>
  userId?: string
  lockedBy?: string
  lockByEmail?: string
}) => {
  const { classes } = useStyles({})
  const timeDiff = Math.ceil(
    DateTime.now().diff(
      sinceTime ? DateTime.fromISO(sinceTime) : DateTime.now(),
      ['seconds']
    ).seconds
  )
  const [time, setTime] = useState(timeDiff)

  useEffect(() => {
    const timer = setInterval(() => {
      const timeDiffnew = Math.ceil(
        DateTime.now().diff(
          sinceTime ? DateTime.fromISO(sinceTime) : DateTime.now(),
          ['seconds']
        ).seconds
      )
      setTime(timeDiffnew)
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [sinceTime])

  if (time > autoSaveThresoldTime && lockStatus === footerStateType.LOCKED) {
    setLockStatus(footerStateType.UNLOCKED)
  }
  return (
    <div className={classes.lockStatusMsg} data-testid={'lock-state'}>
      {lockStatus === footerStateType.LOCKED && (
        <>
          <FontAwesomeIcon
            style={{ width: '20px', height: '14px' }}
            icon={faTriangleExclamation}
          />
          {lockedBy === userId ? (
            'This form is currently being edited in another tab. Please close one of the tabs to continue and please wait for 3 mins and refresh the page.'
          ) : (
            <>
              page is currently being edited by{' '}
              <span className={classes.userName}>
                {lockByName} ({lockByEmail})
              </span>{' '}
              please wait for 3 mins after the user logout etc.{' '}
            </>
          )}
        </>
      )}
      {lockStatus === footerStateType.UNLOCKED && (
        <>
          <FontAwesomeIcon
            style={{ width: '20px', height: '14px' }}
            icon={faFaceSmile}
          />
          <span data-testid={'unlock-section'} className={classes.userName}>
            {lockByName} ({lockByEmail})
          </span>{' '}
          has finished editing. You can now begin editing the form.
        </>
      )}
    </div>
  )
}
